import React from 'react';

export default function (props) {
    return (
        <div className="info">
            <p>{props.info}</p>
        </div>
    );
}
